import { render, staticRenderFns } from "./list.html?vue&type=template&id=9923a0e6&scoped=true&"
import script from "./ListItemService.vue?vue&type=script&lang=js&"
export * from "./ListItemService.vue?vue&type=script&lang=js&"
import style0 from "./ListItemService.vue?vue&type=style&index=0&id=9923a0e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9923a0e6",
  null
  
)

export default component.exports